import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ background: 'var(--bg-primary)', borderTop: '1px solid var(--border)', padding: '80px 0 40px' }}>
      <div className="container">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 48, marginBottom: 60 }}>
          {/* Col 1 - Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
              <div style={{ width: 28, height: 28, borderRadius: '50%', background: 'linear-gradient(135deg, #00AEEF 0%, #0066AA 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 12, color: '#fff' }}>A</span>
              </div>
              <span style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 16, color: 'var(--text-primary)' }}>Alercell®</span>
            </div>
            <p style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.6 }}>
              Alercell, Inc.<br />
              Bozeman, Montana<br />
              United States
            </p>
            <a href="mailto:info@alercell.com" style={{ display: 'block', marginTop: 12, fontSize: 13, color: 'var(--accent-cyan)', textDecoration: 'none' }}>
              info@alercell.com
            </a>
          </div>

          {/* Col 2 - Platform */}
          <div>
            <h4 style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--accent-cyan)', textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: 20 }}>Platform</h4>
            {['LENA Q51®', 'LENA S1®', 'LENA Code®', 'LENA Score™', 'LENA-Rx™', 'Deep Leukemic Cloud®', 'LENA Epigenetic Clock™'].map(p => (
              <Link key={p} to="/platform" style={{ display: 'block', fontSize: 13, color: 'var(--text-secondary)', textDecoration: 'none', marginBottom: 8, transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color = 'var(--text-primary)'}
                onMouseLeave={e => e.target.style.color = 'var(--text-secondary)'}
              >{p}</Link>
            ))}
          </div>

          {/* Col 3 - Company */}
          <div>
            <h4 style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--accent-cyan)', textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: 20 }}>Company</h4>
            {[
              { label: 'About', path: '/about' },
              { label: 'Science', path: '/science' },
              { label: 'Investors', path: '/investors' },
              { label: 'News', path: '/news' },
              { label: 'Careers', path: '/career' },
              { label: 'Contact', path: '/contact' },
            ].map(link => (
              <Link key={link.path} to={link.path} style={{ display: 'block', fontSize: 13, color: 'var(--text-secondary)', textDecoration: 'none', marginBottom: 8, transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color = 'var(--text-primary)'}
                onMouseLeave={e => e.target.style.color = 'var(--text-secondary)'}
              >{link.label}</Link>
            ))}
          </div>

          {/* Col 4 - Resources */}
          <div>
            <h4 style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--accent-cyan)', textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: 20 }}>Resources</h4>
            {[
              { label: 'White Papers', path: '/science#publications' },
              { label: 'Research & Reproducibility', path: '/research' },
              { label: 'Publications', path: '/science#publications' },
              { label: 'Patent Portfolio', path: '/platform' },
              { label: 'Substack', path: 'https://fscheer.substack.com', external: true },
            ].map(link => (
              link.external
                ? <a key={link.label} href={link.path} target="_blank" rel="noopener noreferrer" style={{ display: 'block', fontSize: 13, color: 'var(--text-secondary)', textDecoration: 'none', marginBottom: 8 }}>{link.label} ↗</a>
                : <Link key={link.label} to={link.path} style={{ display: 'block', fontSize: 13, color: 'var(--text-secondary)', textDecoration: 'none', marginBottom: 8 }}>{link.label}</Link>
            ))}
          </div>
        </div>

        {/* Legal line */}
        <div style={{ borderTop: '1px solid var(--border)', paddingTop: 28, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 16 }}>
          <p style={{ fontSize: 11, color: 'var(--text-muted)', lineHeight: 1.6, maxWidth: 700 }}>
            © 2026 Alercell, Inc. All rights reserved. LENA Q51®, LENA Code®, LENA Score™, LENA-Rx™, Deep Leukemic Cloud®, and LENA Epigenetic Clock™ are trademarks or registered trademarks of Alercell, Inc.
          </p>
          <div style={{ display: 'flex', gap: 20 }}>
            <a href="#" style={{ fontSize: 11, color: 'var(--text-muted)', textDecoration: 'none' }}>Privacy Policy</a>
            <a href="#" style={{ fontSize: 11, color: 'var(--text-muted)', textDecoration: 'none' }}>Terms of Use</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
